import { Outlet } from "react-router-dom"

import { Footer } from "@/App/Footer"
import { Header } from "@/App/Header"
import { LayoutProvider } from "@/App/LayoutContext"

export const MainLayout = () => (
  <LayoutProvider>
    <div className="mx-auto my-0 flex w-full items-center justify-center overflow-hidden select-none">
      <div className="grid h-dvh w-full grid-rows-[auto_1fr_auto] overflow-hidden border-(length:--spacing-sm) border-solid border-(--bg-primary) bg-primary text-primary">
        <Header />
        <div className="flex w-full overflow-hidden">
          <Outlet />
        </div>
        <Footer />
      </div>
    </div>
  </LayoutProvider>
)
